export const LIVE_CHAT = '/live-chats/viewLiveChats'
export const LIVE_CHAT_DELETED = '/live-chats/chatMessageDeleted'
